package de.ohhhmhhh.frontend.admin.ui.screens.workout.list

import kotlinx.datetime.LocalDate

data class WorkoutListState(
    val items: List<LocalDate> = emptyList()
)
